import { formatAtlanticTime } from '@/utils/time.utils.ts';
import { useTranslation } from 'react-i18next';

interface EventTimeProps {
  startDateTime: string;
  endDateTime: string;
}

export const EventTime = ({ startDateTime, endDateTime }: EventTimeProps) => {
  const { t, i18n } = useTranslation('common');

  if (!startDateTime) return null;

  return (
    <div className="text-sm text-(--color-neutral-700) text-center">
      <p>
        {t('events.start')}: {formatAtlanticTime(new Date(startDateTime), i18n.language)}
      </p>
      <p>
        {t('events.end')}: {formatAtlanticTime(new Date(endDateTime), i18n.language)}
      </p>
    </div>
  );
};
